export default "__VITE_ASSET__422e6032__"